window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".c-hero-color").forEach(hero => {
    const container = hero.querySelector(".hero-container");
    const image = hero.querySelector(".c-image");
    if (!container || !image) return;
    window.addEventListener("resize", () => {
      if (window.innerWidth > 834) image.style.setProperty("transform", `translateX(${window.getComputedStyle(container)?.getPropertyValue("margin-right") ?? "0"})`);else image.style.setProperty("transform", "");
    }, {
      passive: true
    });
    image.classList.remove("hidden");
  });
});